module.exports = __webpack_public_path__ + "img/icon-response-red.b69659b9.svg";